import { render, staticRenderFns } from "./card-text.vue?vue&type=template&id=9c6402b0&scoped=true"
import script from "./card-text.vue?vue&type=script&lang=js"
export * from "./card-text.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c6402b0",
  null
  
)

export default component.exports